<app-general-header></app-general-header>

@if ({loading: loading$ | async, loadingBody: loadingBody$ | async, page: page$ | async}; as extracted) {
  <div class="b-container blog public-text-page">
    <a class="blog__back-link" routerLink="..">
      <img class="blog__back-link-image" src="/assets/images/dashboard/left-arrow--blue.svg" alt="">
      <span class="blog__back-link-text">All Posts</span>
    </a>

    <rt-loading [while]="extracted.loading">
      @if (extracted.page) {
        <div>
          <div class="blog__image-wrap">
            <img class="blog__image" [src]="extracted.page?.thumbnail?.url" alt="">
          </div>

          <h1 class="header-title">{{extracted.page.title}}</h1>

          <div class="blog__date">{{extracted.page?.date ? (extracted.page.date  | date: 'MMMM d, y') : ''}}</div>

          <div [innerHTML]="extracted.page['intro_html'] | safeHtml" class="blog-intro"></div>
          <rt-loading [while]="extracted.loadingBody">
            @if (extracted.page['body_html']) {
              <div [innerHTML]="extracted.page['body_html'] | safeHtml"  class="blog-body"></div>
            }
          </rt-loading>
          @if (extracted.page.tags && extracted.page.tags.length) {
            <div class="tags">
              Tags:
              @for (tag of extracted.page.tags; track tag; let last = $last) {
                <a class="blog-tag" [routerLink]="['/blog/tag/', tag]">{{tag}}</a>
                @if (!last) {
                  <span>, </span>
                }
              }
            </div>
          }
        </div>
      }
    </rt-loading>
    <div class="blog-footer">
      <div class="blog-share">
        Share:
        <div class="social-items-wrap">
          <div class="social-item follow-us__social-item">
            <a class="link social-item__link" (click)="shareOnLinkedIn(extracted.page.title)">
              <img class="social-item-link" src="/assets/images/contact-us/linkedin-icon.svg" alt="linkedin">
            </a>
          </div>
          <div class="social-item follow-us__social-item">
            <a class="link social-item__link" (click)="shareOnFacebook(extracted.page.title)">
              <img class="social-item-link" src="/assets/images/contact-us/facebook-icon.svg" alt="facebook">
            </a>
          </div>
          <div class="social-item follow-us__social-item">
            <a class="link social-item__link" (click)="shareOnX(extracted.page.title)">
              <img class="social-item-link" src="/assets/images/contact-us/x-icon.svg" alt="x">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<app-explore-your-brain callToActionButtonLink="/dashboard"></app-explore-your-brain>

<app-footer></app-footer>
